/**
 * Common API response types.
 *
 * 실제 스키마는 `docs/20260512_165854_API_명세서_v1.0_20260409.md` 를 따른다.
 * Variant/화면 구현 시 domain 별 types 로 분리할 예정.
 */

/** Backend 표준 응답 래퍼 {data, message, code}. */
export interface ApiResponse<T> {
  data: T
  message: string
  code: number
}

/** Generic paginated list envelope (data 내부). */
export interface PaginatedData<T> {
  items: T[]
  total: number
  page: number
  size: number
  pages: number
}

/** Backend standard error payload. */
export interface ApiErrorPayload {
  detail: string | Record<string, unknown>
  code?: string
  errors?: Record<string, string[]>
}

/** Raised by the fetch wrapper on non-2xx responses. */
export class ApiError extends Error {
  readonly status: number
  readonly payload: ApiErrorPayload | undefined
  /** 429 응답의 `Retry-After`(초). 그만큼 기다렸다 다시 보내야 한다. */
  readonly retryAfter: number | undefined

  constructor(status: number, message: string, payload?: ApiErrorPayload, retryAfter?: number) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.payload = payload
    this.retryAfter = retryAfter
  }
}

/**
 * 401 미인증 에러 판별. 익명 사용자가 보호 endpoint 호출 시 발생.
 * 일반 에러 (500, 네트워크 등) 와 분기해 로그인 CTA UX 로 안내.
 */
export function isAuthError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401
}

/** Request options forwarded to the fetch wrapper. */
export interface RequestOptions extends Omit<RequestInit, 'body'> {
  body?: unknown
  params?: Record<string, string | number | boolean | string[] | number[] | undefined | null>
}
